var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "grm-body ansi-dataset-panel", attrs: { fluid: "" } },
    [
      _vm.releases.length === 0
        ? _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { staticClass: "text-center grm-empty", attrs: { cols: "12" } },
                [
                  _c("div", { staticClass: "grm-empty-icon" }, [_vm._v("◎")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("No releases available")]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "grm-grid" },
        _vm._l(_vm.releases, function (rel, index) {
          return _c("b-col", { key: index, staticClass: "grm-card-col mb-3" }, [
            _c(
              "div",
              {
                class: [
                  "grm-card",
                  { "grm-card--expanded": _vm.isExpanded(index) },
                ],
                on: {
                  click: function ($event) {
                    return _vm.updateANSIDisplayDataset(
                      rel,
                      `ansi_dataset_column_${index}`,
                      rel.extent_description
                    )
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "grm-card-row d-flex align-items-center w-100",
                  },
                  [
                    _c("div", { staticClass: "grm-map-preview" }, [
                      _c("div", { staticClass: "grm-map-glow" }),
                      _vm._v(" "),
                      _vm.getRegionImage(rel.extent_description)
                        ? _c("img", {
                            staticClass: "grm-map-img",
                            attrs: {
                              src: _vm.getRegionImage(rel.extent_description),
                              alt: rel.extent_description,
                            },
                          })
                        : _c("div", { staticClass: "grm-map-placeholder" }, [
                            _c(
                              "svg",
                              {
                                staticClass: "grm-globe-icon",
                                attrs: {
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "#4db8ff",
                                    "stroke-width": "1.5",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z",
                                    stroke: "#4db8ff",
                                    "stroke-width": "1.5",
                                  },
                                }),
                              ]
                            ),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grm-card-info" }, [
                      _c("div", { staticClass: "grm-region-name" }, [
                        _vm._v(_vm._s(rel.extent_description)),
                      ]),
                      _vm._v(" "),
                      rel.release_label
                        ? _c("div", { staticClass: "grm-release-label" }, [
                            _vm._v(_vm._s(rel.release_label)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "grm-release-date" }, [
                        _c("span", { staticClass: "grm-date-dot" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.formatDate(rel.release_date)) +
                            "\n            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grm-card-action" }, [
                      _c("span", { staticClass: "grm-action-label" }, [
                        _vm._v(
                          _vm._s(_vm.isExpanded(index) ? "Pick" : "Select")
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          staticClass: "grm-action-arrow",
                          attrs: { viewBox: "0 0 16 16", fill: "none" },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M3 8h10M9 4l4 4-4 4",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.isExpanded(index) && _vm.selsets.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "grm-selsets",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "grm-selsets-label" }, [
                          _vm._v("Choose a selection set"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "grm-selsets-row" },
                          _vm._l(_vm.selsets, function (selset, si) {
                            return _c(
                              "button",
                              {
                                key: si,
                                staticClass: "grm-selset-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.updateAnsiDisplaySelset(selset)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(selset.selset) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "grm-card-shine" }),
              ]
            ),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }